const STORAGE_KEY = "spacesheep-max-level";
const STORAGE_LEVEL_KEY = "spacesheep-current-level";
const GAME_STATE_KEY = (level: number) => `spacesheep-game-state-${level}`;

export function getMaxLevelUnlocked() {
  return Number(localStorage.getItem(STORAGE_KEY) || 1);
}
export function saveMaxLevelUnlocked(level: number) {
  localStorage.setItem(STORAGE_KEY, String(level));
}

export function getInitialLevel() {
  const raw = localStorage.getItem(STORAGE_LEVEL_KEY);
  const parsed = raw ? Number(raw) : undefined;
  if (parsed && !isNaN(parsed)) return parsed;
  return getMaxLevelUnlocked();
}
export function saveCurrentLevel(level: number) {
  localStorage.setItem(STORAGE_LEVEL_KEY, String(level));
}
export function removeCurrentLevel() {
  localStorage.removeItem(STORAGE_LEVEL_KEY);
}

export function saveGameState(level: number, state: any, primes: [bigint, bigint, bigint]) {
  localStorage.setItem(
    GAME_STATE_KEY(level),
    JSON.stringify({
      ...state,
      p: primes[0].toString(),
      q: primes[1].toString(),
      N: primes[2].toString(),
    })
  );
}

export function patchGameState(level: number, patch: Partial<any>) {
  const raw = localStorage.getItem(GAME_STATE_KEY(level));
  const prev = raw ? JSON.parse(raw) : {};
  localStorage.setItem(
    GAME_STATE_KEY(level),
    JSON.stringify({ ...prev, ...patch })
  );
}

export function loadGameState(level: number) {
  const raw = localStorage.getItem(GAME_STATE_KEY(level));
  if (!raw) return null;
  const data = JSON.parse(raw);
  // Jeśli są p, q, N – konwertuj na bigint
  if (data.p && data.q && data.N) {
    data.p = BigInt(data.p);
    data.q = BigInt(data.q);
    data.N = BigInt(data.N);
  }
  return data;
}

export function clearGameState(level: number) {
  localStorage.removeItem(GAME_STATE_KEY(level));
}
